import { RouterView } from 'vue-router';
import { anyPermission } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';
import { plannerDossierLoader } from '../dossier/loaders';

const PlannerPage = () => import('./views/PlannerPage.vue');
const PlannerSidebarCollapsedView = () => import('./views/PlannerSidebarCollapsedView.vue');
const NewEventView = () => import('./views/NewEventView.vue');
const PlannerEventView = () => import('./views/PlannerEventView.vue');
const PlannerDossierListView = () => import('./views/PlannerDossierListView.vue');
const PlannerDossierView = () => import('./views/PlannerDossierView.vue');

export default [
  {
    path: '/planner/:date?',
    name: 'planner-root',
    component: PlannerPage,
    meta: {
      title: 'planner.title',
      inPlanner: true,
      hasAccess: anyPermission(
        Permission.WORKSHOP_PLANNING_READ_ACCESS,
        Permission.WORKSHOP_PLANNING_WRITE_ACCESS,
      ),
      load: ['workshopPlanning/open'],
      unload: ['workshopPlanning/close', 'workshopPlanning/clearPlannedEvents'],
      logicalModule: 'planner',
      logicalParents: ['tasks', 'dossier-detail'],
    },
    children: [
      {
        path: '',
        name: 'planner-home',
        component: PlannerSidebarCollapsedView,
      },
      {
        path: 'new',
        name: 'planner-new-event',
        component: NewEventView,
        meta: {
          hasAccess: anyPermission(Permission.WORKSHOP_PLANNING_WRITE_ACCESS),
        },
      },
      {
        path: '',
        name: 'planner-sidebar',
        component: RouterView,
        meta: {
          unload: ['workshopPlanning/clearCurrent', 'dossierDetails/clear'],
        },
        children: [
          {
            path: 'event/:eventId',
            name: 'planner-event',
            component: PlannerEventView,
            props: {
              context: plannerDossierLoader,
            },
            meta: {
              load: ['workshopPlanning/openEvent'],
            },
          },
          {
            path: 'dossiers',
            name: 'planner-dossier-list',
            component: PlannerDossierListView,
            meta: {
              load: ['workshopPlanning/openDossierList'],
            },
          },
          {
            path: 'dossiers/:dossierId',
            name: 'planner-dossier',
            component: PlannerDossierView,
            props: {
              context: plannerDossierLoader,
            },
            meta: {
              load: ['workshopPlanning/openDossier'],
            },
          },
        ],
      },
    ],
  },
];
